import './App.css';
import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { customTheme } from './theme/customTheme';
import { authProvider } from './Provider/parseAuthProvider';
import { dataProvider } from './Provider/parseDataProvider';
import Login from './pages/auth/Login';
import OperatorManagement from './pages/operators/OperatorManagement';
import AdminOtpVerification from './pages/auth/AdminOtpVerification';
import AdminList from './pages/admins/AdminList';
import OperatorGamesList from './pages/operatorGames/OperatorGamesList';
import Profile from './pages/profile/Profile';
import AdminActivityLogs from './pages/adminActivityLogs/AdminActivityLogs';
import { CustomLayout } from './layouts/CustomLayout';
import { SectionGuard } from './components/SectionGuard';
import HomeRedirect from './pages/HomeRedirect';
import BusinessIcon from '@mui/icons-material/Business';
import { GameRecordList } from './pages/GameRecords/GameRecords';
import CasinoIcon from '@mui/icons-material/Casino';
import TuneIcon from '@mui/icons-material/Tune';
import { GameBetConfig } from './pages/GameBetConfig/GameBetConfig';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

/**
 * Wrap a resource list so opening it by URL is checked against the user's
 * granted sections, the same way the sidebar decides what to show.
 */
const guard = (Component) => {
  const Guarded = (props) => (
    <SectionGuard>
      <Component {...props} />
    </SectionGuard>
  );
  Guarded.displayName = `Guarded(${Component.displayName || Component.name || 'Component'})`;
  return Guarded;
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <Admin
          authProvider={authProvider}
          dataProvider={dataProvider}
          loginPage={Login}
          layout={CustomLayout}
          theme={customTheme}
          dashboard={HomeRedirect}
          requireAuth
        >
          <Resource name="operators" list={guard(OperatorManagement)} icon={BusinessIcon} />
          <Resource
            name="operatorGames"
            list={guard(OperatorGamesList)}
            options={{ label: 'Operator Games' }}
            icon={TuneIcon}
          />
          <Resource
            name="GameCatalogue"
            list={guard(GameRecordList)}
            options={{ label: 'Game Records' }}
            icon={CasinoIcon}
          />
          <Resource
            name="GameBetConfig"
            list={guard(GameBetConfig)}
            options={{ label: 'Game Bet Levels' }}
            icon={CurrencyExchangeIcon}
          />

          <CustomRoutes>
            {/* OTP verification is part of signing in, so it is never gated. */}
            <Route path="/admin-otp-verification" element={<AdminOtpVerification />} />
            <Route
              path="/admins"
              element={
                <SectionGuard>
                  <AdminList />
                </SectionGuard>
              }
            />
            <Route
              path="/profile"
              element={
                <SectionGuard>
                  <Profile />
                </SectionGuard>
              }
            />
            <Route
              path="/admin-activity-logs"
              element={
                <SectionGuard>
                  <AdminActivityLogs />
                </SectionGuard>
              }
            />
          </CustomRoutes>
        </Admin>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
